import { render, staticRenderFns } from "./PayrollResourceList.vue?vue&type=template&id=3e1f8085&"
import script from "./PayrollResourceList.vue?vue&type=script&lang=js&"
export * from "./PayrollResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports